import { GOAL_APP_SETTINGS_PAGE, GOAL_APP_SETTINGS_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const goalSettingsRoute = createGlobalRoute({
  exact: true,
  name: GOAL_APP_SETTINGS_PAGE,
  path: GOAL_APP_SETTINGS_PATH,
  capabilities: ['goals_app:administer'],
  subproduct: 'townsquare-goals',
  enableRestrictedFallback: true,
});
